<template>
  <div class="container-custom" v-if="category !== null">
    <v-form ref="form" @submit.prevent="saveHandler">
      <!-- breadcrumbs -->
      <Breadscrumbs
        :links="[
          {
            name: 'Category',
            to: {
              name: 'Category'
            }
          },
          // {
          //   name: 'Category Info',
          //   to: {
          //     name: 'CategoryInfo'
          //   }
          // },
          {
            name: 'Edit',
            to: {
              name: 'CategoryInfoEdit',
              params: {
                id: $route.params.id
              },
            }
          },
        ]"
      ></Breadscrumbs>
      <!-- page-actions -->
      <div class="page-actions">
        <h2>編輯分類</h2>
        <v-spacer></v-spacer>
        <button class="btn mr-5" @click="cancelHandler">
          <span>取消</span>
        </button>
        <button class="btn btn-primary" type='submit'>
          <span>儲存</span>
        </button>
      </div>
    </v-form>

    <!-- block -->
    <div class="block">
      <!-- Category Name -->
      <label class="form-item py-5 d-flex">
        <h4 class="w-240px mr-10">Category Name <span class="text-danger">*</span></h4>
        <div class="form-input-group w-248px my-n2">
          <input type="text" placeholder="請輸入分類名稱" v-model="category.name" />
        </div>
      </label>
      <!-- BU -->
      <div class="form-item py-5 d-flex">
        <h4 class="w-240px mr-10">BU <span class="text-danger">*</span></h4>
        <div class="w-248px my-n2 category-autocomplete">
          <v-autocomplete
            v-model="category.bu_id"
            :items="buTabs"
            placeholder="請選擇所屬BU"
            item-text="name"
            item-value="id"
            outlined
            dense
          >
          </v-autocomplete>
        </div>
      </div>
      <!-- Category Type -->
      <div class="form-item py-5 d-flex" v-if="category.bu_id == 1" >
        <h4 class="w-240px mr-10">Category Type <span class="text-danger">*</span></h4>
        <div class="w-248px my-n2 category-autocomplete">
          <v-radio-group v-model="category.category_type" row>
            <div
              v-for="item in [
                { label: '預設', value: 'category' },
                { label: '整機', value: 'assembly' },
              ]"
              :key="item.value"
              class="w-33"
            >
              <v-radio class="mr-01" :value="item.value">
                <template v-slot:label>
                  <div class="ink-01-emphasis--text w-202px">
                    {{ item.label }}
                  </div>
                </template>
              </v-radio>
            </div>
          </v-radio-group>
        </div>
      </div>
      <!-- ID -->
      <label class="form-item py-5 d-flex">
        <h4 class="w-240px mr-10">ID</h4>
        <div class="d-flex">
          <div class="form-input-group w-248px my-n2">
            <input type="text" :value="category.id" disabled />
          </div>
        </div>
      </label>
      <!-- Order -->
      <label class="form-item py-5 d-flex">
        <div class="w-240px mr-10">
          <h4 class="mb-10px">Order</h4>
          <div class="h5 ink-02-medium--text">
            資料降冪排序(數字越大顯示越前面)
          </div>
        </div>
        <div class="form-input-group w-248px my-n2">
          <input type="text" placeholder="請輸入序號" v-model="category.order"/>
        </div>
      </label>
      <!-- 顯示/隱藏 -->
      <label class="form-item py-5 d-flex">
        <div class="w-240px mr-10">
          <h4>顯示/隱藏</h4>
        </div>
        <div>
          <FormSwitch v-model="category.status"></FormSwitch>
        </div>
      </label>
      <!-- Slug -->
      <label class="form-item d-flex pt-5">
        <div class="w-240px mr-10">
          <h4>Slug</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="category.slug"
            placeholder="可讀性URL"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- SEO TITLE -->
      <label class="form-item d-flex pt-5">
        <div class="w-240px mr-10">
          <h4>SEO Title</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="category.seo_title"
            placeholder="SEO Title"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- SEO Description -->
      <label class="form-item d-flex pt-5">
        <div class="w-240px mr-10">
          <h4>SEO Description</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-textarea
            v-model="category.seo_description"
            outlined
            dense
          ></v-textarea>
        </div>
      </label>
      <!-- 圖片 -->
      <div class="form-item py-5 d-flex">
        <div class="w-240px mr-10">
          <h4 class="mb-10px">圖片</h4>
          <div class="h5 ink-02-medium--text">
            此圖將顯示於官網BU Page <br />
            建議尺寸：999px * 999px <br />
            檔案大小限制：&lt; 1 MB
          </div>
        </div>
        <div>
          <ImgUploader
            :imageUrl.sync="category.image"
            dir="category"></ImgUploader>
        </div>
      </div>
    </div>

    <!--Category Banner-->
    <h3 class="mb-5 mt-5">Category Banner</h3>
    <div class="h4 mb-5">
      若要新增Banner數量，請點擊下方 [添加Banner] 按鈕，前台最多顯示四個。<br>
      使用於 Category Page 上方的輪播廣告區塊。<br>
      支援置中橫幅banner<br>
    </div>
    <!-- items -->
    <PageCollapse v-for="(item, i) in category.banners" :key="i">
      <template v-slot:head>
        <h3 class="mr-auto">Banner {{ i + 1 }}</h3>
      </template>
      <template v-slot:actions>
        <div class="ml-auto">
          <button class="btn square mr-10px" @click="deleteBanner(i)">
            <v-icon class="ink-02-medium--text">delete</v-icon>
          </button>
          <button class="btn square mr-10px" @click="downBanner(item, i)">
            <v-icon class="ink-02-medium--text">arrow_downward</v-icon>
          </button>
          <button class="btn square" @click="upBanner(item, i)">
            <v-icon class="ink-02-medium--text">arrow_upward</v-icon>
          </button>
        </div>
      </template>
      <template v-slot:body>
        <!-- Title -->
        <label class="form-item d-flex pb-3">
          <h4 class="w-180px mt-5">Title</h4>
          <div class="flex-grow-1 mt-3">
            <div class="form-input-group">
              <input
                type="text"
                placeholder="請輸入 Title"
                v-model="item.title"
              />
            </div>
          </div>
        </label>
        <!-- Slogan/Description -->
        <label class="form-item d-flex pb-3">
          <h4 class="w-180px mt-5">Slogan</h4>
          <div class="flex-grow-1 mt-3">
            <div class="form-input-group">
              <input
                type="text"
                placeholder="請輸入 Slogan"
                v-model="item.description"
              />
            </div>
          </div>
        </label>
        <!-- Banner 顯示位置 -->
        <div class="form-item d-flex pb-3" v-if="category.bu_id == 1 || category.bu_id == 2">
          <h4 class="w-180px mt-5">Banner位置</h4>
          <div class="flex-grow-1 mt-3">
            <v-radio-group v-model="item.banner_position" row>
              <div
                v-for="item in [
                  { label: '預設', value: null },
                  { label: '置中', value: 'middle' },
                ]"
                :key="item.value"
                class="w-33"
              >
                <v-radio class="mr-01" :value="item.value">
                  <template v-slot:label>
                    <div class="ink-01-emphasis--text w-202px">
                      {{ item.label }}
                    </div>
                  </template>
                </v-radio>
              </div>
            </v-radio-group>
          </div>
        </div>
        <!-- img uploader -->
        <div class="d-flex px-5 pt-5 mb-8">
          <div class="w-180px">
            <h4 class="mb-10px">Visual</h4>
            <div class="h5 ink-02-medium--text">
              建議尺寸： <br />
              ADATA: 無此功能 <br />
              XPG: 1920 px X 640 px <br/>
              置中尺寸  <br />
              ADATA: 無此功能 <br />
              XPG: 1920 px X 400 px <br/>
              檔案大小限制：&lt; 1 MB
            </div>
          </div>
          <div class="d-flex justify-end flex-grow-1">
            <ImgUploader
              :imageUrl.sync="item.visual"
              dir="category"></ImgUploader>
          </div>
        </div>
        <!-- img uploader -->
        <div class="d-flex px-5 pt-5 mb-8">
          <div class="w-180px">
            <h4 class="mb-10px">Mobile Visual</h4>
            <div class="h5 ink-02-medium--text">
              建議尺寸：<br />
              ADATA: 無此功能 <br />
              XPG: 480 px X 650 px <br/>
              檔案大小限制：&lt; 1 MB
            </div>
          </div>
          <div class="d-flex justify-end flex-grow-1">
            <ImgUploader
              :imageUrl.sync="item.image_mobile"
              dir="category"></ImgUploader>
          </div>
        </div>
        <!-- URL -->
        <label class="form-item d-flex py-5">
          <div class="w-240px">
            <h4>URL</h4>
          </div>
          <div class="flex-grow-1 flex-basis-0 my-n2">
            <v-text-field
              v-model="item.url"
              prepend-inner-icon="mdi-link"
              outlined
              dense
            ></v-text-field>
          </div>
        </label>
        <!-- 顯示/隱藏 -->
        <div class="form-item d-flex py-5">
          <div class="w-240px mr-5">
            <h4>顯示/隱藏</h4>
          </div>
          <div class="flex-grow-1 flex-basis-0">
            <FormSwitch v-model="item.status"></FormSwitch>
          </div>
        </div>
        <!-- Order -->
        <label class="form-item d-flex pb-3">
          <div class="w-240px mr-5">
            <h4>Order</h4>
            <div class="h5 ink-02-medium--text">
              資料降冪排序(數字越大顯示越前面)
            </div>
          </div>
          <div class="flex-grow-1 mt-3">
            <div class="form-input-group">
              <input
                type="text"
                placeholder="請輸入 order"
                v-model="item.order"
              />
            </div>
          </div>
        </label>
      </template>
    </PageCollapse>
    <!-- 添加Company Culture -->
    <div class="mt-5">
      <button class="btn btn-outlined w-100 justify-start" @click="addBanner">
        <v-icon class="primary--text mr-2">add_circle</v-icon>
        <span>添加Banner</span>
      </button>
    </div>

    <LangDialog :isOpen.sync="isLangOpen" @confirm-submit="saveHandler()"></LangDialog>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import FormSwitch from '@/components/FormSwitch.vue';
import ImgUploader from '@/components/ImgUploader.vue';
import LangDialog from '@/components/LangSubmitDialog.vue';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import PageCollapse from '@/components/PageCollapse.vue';

export default {
  components: {
    FormSwitch,
    ImgUploader,
    LangDialog,
    Breadscrumbs,
    PageCollapse,
  },
  data: () => ({
    isLangOpen: false,
  }),
  computed: {
    ...mapState(['lang', 'buTabs']),
    ...mapState('category', ['category']),
  },
  async created() {
    if (this.$route.params.id) {
      await this.getCategory(this.$route.params.id);
    }
  },
  methods: {
    ...mapActions('category', {
      getCategory: 'findById',
      save: 'save',
      clear: 'clear',
    }),
    addBanner() {
      const template = {
        id: null,
        title: '',
        description: '',
        visual: '',
        image_mobile: '',
        status: true,
        order: 0,
      };
      this.category.banners.push(template);
    },
    deleteBanner(index) {
      this.category.banners.splice(index, 1);
    },
    downBanner(item, i) {
      // if i is last, then item become the first index
      if (i === this.category.banners.length - 1) {
        this.category.banners.splice(i, 1);
        this.category.banners.unshift(item);
        return;
      }
      // item become next index
      this.category.banners.splice(i, 1);
      this.category.banners.splice(i + 1, 0, item);
    },
    upBanner(item, i) {
      // if i = 0, then item go to the last one
      if (i === 0) {
        this.category.banners.splice(i, 1);
        this.category.banners.push(item);
        return;
      }
      // item become previous index
      this.category.banners.splice(i, 1);
      this.category.banners.splice(i - 1, 0, item);
    },
    cancelHandler() {
      this.$router.push({ name: 'Category' });
    },
    saveHandler() {
      if (this.isLangOpen || !this.lang.id) {
        this.errors = [];
        if (this.$refs.form.validate()) {
          if (!this.category.name) {
            this.errors.push('Category Name required.');
          }
          if (!this.category.bu_id) {
            this.errors.push('BU required.');
          }
          /*
          if(this.category.banners.length > 0){
            this.category.banners.forEach(item => {
              if(!item.title)
              {
                this.errors.push('Banner Title requred.');
              }
            });
          }
          */
          if (this.errors.length > 0) {
            /* eslint-disable */
            alert(this.errors);
            /* eslint-disable */
            return false;
          }
          this.save(this.category).then(() => {
            this.$router.push({ name: 'Category' });
            this.clear();
          });
        }
      } else {
        this.isLangOpen = true;
      }
    },
  },
};
</script>

<style lang="scss">
.category-autocomplete {
  .v-autocomplete {
    .v-input__slot {
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
    .v-text-field__details {
      display: none;
    }
  }

  // border
  fieldset {
    border-color: #d7dee7;
    border-radius: 8px;
  }
  .v-input--is-focused {
    border-color: $brand-500;
  }

  // placeholder color
  input::placeholder {
    color: #848fa0 !important;
  }
}
</style>